import React, {useState} from 'react';

import {StarsPicker} from './Stars';
import {submitReview} from '../api';
import {writeOwnReview} from '../cookie';

const MIN_TEXT = 10;
const MAX_TEXT = 200;

// Sidebar review form. Mirrors legacy `templates/reviews.phtml`
// `.sidebar-item.testimonial-form-sidebar > form#review` markup so
// the existing `redesign.css :.testimonial-form*` rules paint it
// unchanged. State + submission lives in React; cookie write on
// success keeps the "stays on top after refresh" UX from legacy.
//
// `onPublished(payload)` callback bubbles the resolved review back to
// the page so it can prepend the freshly-rendered ReviewItem to the
// list AND hide the form (matches legacy `$('.testimonial-form-
// sidebar').remove()` after a successful save).
export default function ReviewForm({onPublished}) {
    const [orderId, setOrderId] = useState('');
    const [rate, setRate] = useState(0);
    const [text, setText] = useState('');
    const [errors, setErrors] = useState({orderId: false, rate: false, text: false, textShort: false, orderIdInvalid: false});
    const [serverError, setServerError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (submitting) return;

        const next = {orderId: false, rate: false, text: false, textShort: false, orderIdInvalid: false};
        let bad = false;
        if (!orderId.trim())             { next.orderId = true; bad = true; }
        if (!rate)                       { next.rate = true; bad = true; }
        if (!text.trim())                { next.text = true; bad = true; }
        else if (text.trim().length < MIN_TEXT) { next.textShort = true; bad = true; }
        setErrors(next);
        if (bad) return;

        setSubmitting(true);
        setServerError('');
        try {
            const data = await submitReview({
                orderId: orderId.trim(),
                rate,
                message: text.trim(),
            });

            // Backend (essay-db SubmitReview) responds with
            // `{status: true}` plus — when proxied through the legacy
            // path — additional `data` describing the order/writer
            // shape. Build a feedback row from whatever we know so the
            // page can prepend it immediately without a refetch.
            const ownReview = {
                customer: {name: data?.data?.customer?.name || 'You'},
                rate,
                message: text.trim(),
                date: Date.now(),
                order: {
                    workType: data?.data?.order?.work_type || data?.data?.order?.workType || '',
                    subject:  data?.data?.order?.subject_type || data?.data?.order?.subject || '',
                    pages:    data?.data?.order?.pages || '',
                },
                writer: {
                    id:   data?.data?.writer?.id || 0,
                    name: data?.data?.writer?.name || 'your writer',
                },
            };
            writeOwnReview(ownReview);
            onPublished(ownReview);
        } catch (err) {
            const fieldErrors = err?.errors || {};
            if (fieldErrors.order_id) {
                setErrors((s) => ({...s, orderIdInvalid: true}));
            } else if (fieldErrors.text) {
                const firstMsg = Array.isArray(fieldErrors.text) ? fieldErrors.text[0] : fieldErrors.text;
                setServerError(typeof firstMsg === 'string' ? firstMsg : 'Review text is too short.');
            } else if (fieldErrors.rating) {
                const firstMsg = Array.isArray(fieldErrors.rating) ? fieldErrors.rating[0] : fieldErrors.rating;
                setServerError(typeof firstMsg === 'string' ? firstMsg : 'Invalid rating.');
            } else if (err?.status === 401 || err?.status === 403) {
                setServerError('Please sign in to leave a review.');
            } else {
                setServerError('Server error. Please contact technical support.');
            }
            setSubmitting(false);
        }
    };

    return (
        <div className="sidebar-item testimonial-form-sidebar">
            <form id="review" onSubmit={onSubmit} noValidate>
                <p className="title">Write review</p>
                <div className={`info__item${errors.orderId ? ' error' : ''}${errors.orderIdInvalid ? ' errorId' : ''}`}>
                    <input
                        className="testimonial-form__order"
                        type="text"
                        placeholder="Type your Order ID"
                        value={orderId}
                        onChange={(e) => {
                            setOrderId(e.target.value);
                            setErrors((s) => ({...s, orderId: false, orderIdInvalid: false}));
                        }}
                    />
                    <span className="info__item--error">Please type your Order ID.</span>
                    <span className="info__item--errorId">That ID does not exist</span>
                </div>
                <div className={`testimonial-form__review-rate info__item${errors.rate ? ' error' : ''}`}>
                    <p>Rate writer:</p>
                    <StarsPicker
                        value={rate}
                        onChange={(v) => {
                            setRate(v);
                            setErrors((s) => ({...s, rate: false}));
                        }}
                    />
                    <span className="info__item--error">Please rate the writer.</span>
                </div>
                <div className="testimonial-form__user-text">
                    <div className={`info__item${errors.text || errors.textShort ? ' error' : ''}`}>
                        <textarea
                            className="testimonial-form__text"
                            placeholder="Leave a review"
                            maxLength={MAX_TEXT}
                            value={text}
                            onChange={(e) => {
                                setText(e.target.value);
                                setErrors((s) => ({...s, text: false, textShort: false}));
                            }}
                        />
                        <span className="info__item--error">
                            {errors.textShort
                                ? `Please write at least ${MIN_TEXT} characters.`
                                : 'Please type your review.'}
                        </span>
                    </div>
                    <p className="testimonial-form__text--legth">
                        <span className="count">{text.length}</span>/{MAX_TEXT}
                    </p>
                </div>
                <button
                    type="submit"
                    disabled={submitting}
                    style={submitting ? {backgroundColor: '#999'} : undefined}
                >
                    {submitting ? 'Sending…' : 'Continue'}
                </button>
                {serverError && (
                    <span className="server__error" style={{display: 'block', marginTop: 8, color: '#c62828', fontSize: 13}}>
                        {serverError}
                    </span>
                )}
            </form>
        </div>
    );
}
